/*
  List Reorder Controller

  Handles reordering of list

  DEPENDENCIES
    Each list item must be controller by list-position-controller, as this controller invokes that one
*/

export default class extends Controller {

  connect() {
    this.dragHandler = App.DragHandler.init([this.element], {
      dragHandler: this.hidePositionIndicator.bind(this),
      dragEndHandler: this.updateListPosition.bind(this)
    })
  }

  hidePositionIndicator(el) {
    [...el.querySelectorAll('.hide-on-drag')].forEach(e => App.Helpers.hideElement(e));
  }

  showPositionIndicator(el) {
    [...el.querySelectorAll('.hide-on-drag')].forEach(e => App.Helpers.showElement(e));
  }

  updateListPosition(el) {
    const listPositionController = App.ControlledComponents.findControllerBy({ element: el, name: "list-position" });
    listPositionController.setAllPositions();
    this.showPositionIndicator(el);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/list-reorder-controller.js